import { zahl } from '../lib/format.js'

/**
 * Sitzungsende. DESIGN.md, Risiko 3: Level, Streak und Heatmap gehören nicht auf
 * den Lernbildschirm, sondern hierher — der Lernbildschirm bleibt dadurch ruhig.
 *
 * Kein eigener Router-Eintrag: die Bilanz lebt im Zustand des Lernbildschirms
 * und ginge beim Adresswechsel verloren.
 */

const BEWERTUNGEN = [
  { rating: 'again', label: 'Wieder' },
  { rating: 'hard', label: 'Schwer' },
  { rating: 'good', label: 'Gut' },
  { rating: 'easy', label: 'Einfach' },
]

export function Zusammenfassung({ sitzung, stand, restFaellig, weiter }) {
  return (
    <div class="zusammenfassung">
      <p class="kennzahl">{sitzung.bewertet}</p>
      <p class="meta zusammenfassung__unterzeile">
        {sitzung.bewertet === 1 ? 'Karte bewertet' : 'Karten bewertet'}
      </p>

      <ul class="bilanz">
        {BEWERTUNGEN.map(({ rating, label }) => (
          <li key={rating} class="bilanz__zeile">
            <span class="bilanz__label">{label}</span>
            <span class="bilanz__wert zahl">{sitzung.proBewertung?.[rating] ?? 0}</span>
          </li>
        ))}
      </ul>

      <p class="zusammenfassung__xp zahl">+{zahl(sitzung.xp)}</p>
      <p class="meta">XP in dieser Sitzung</p>

      {stand ? (
        <section class="level" aria-label="Fortschritt">
          {stand.leveled_up ? (
            <p class="zusammenfassung__aufstieg">Stufe {stand.level} erreicht</p>
          ) : null}
          <p class="level__text meta">
            Stufe {stand.level} · <span class="zahl">{zahl(stand.total_xp)}</span> XP
          </p>
          <div
            class="level__balken"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(stand.xp_progress_pct)}
            aria-label={`Fortschritt zu Stufe ${stand.level + 1}`}
          >
            <div class="level__fuellung" style={{ width: `${stand.xp_progress_pct}%` }} />
          </div>
        </section>
      ) : null}

      {/* Plan 3: Streak und Heatmap der letzten Wochen kommen hierhin,
          sobald /api/stats steht. */}

      <div class="zusammenfassung__aktionen">
        {restFaellig > 0 ? (
          <button type="button" class="knopf knopf--haupt" onClick={weiter}>
            Weiter lernen · <span class="zahl">{restFaellig}</span>
          </button>
        ) : null}
        <a class="knopf knopf--still" href="/">
          Zur Themenliste
        </a>
      </div>
    </div>
  )
}
